<template>
  <bill-define :type="type" :options="options"></bill-define>
</template>

<script>
import BillDefine from './component/BillDefine'
export default {
  name: 'percentageDefine',
  components: {BillDefine},
  data () {
    return {
      type: 3,
      options: [
        {
          value: 'commission',
          label: '提成'
        }
      ]
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/percentageDefine.vue